import React from 'react';
import { Box, Preloader, Text } from '@common-fe/common-fe';

import ExpensesBreakdown from '@/modules/employee/Employee/EnrollmentBalances/components/ExpensesBreakdown';

import { useGetEmployeeId } from '../hooks';
import { useExpensesStatisticsQuery } from '../hooks/useExpensesStatistics.query';

import { ExpensesList } from './ExpensesList';

export const ExpenseDetails: React.FC = () => {
  const employeeId = useGetEmployeeId();
  const { formattedData, isLoading } = useExpensesStatisticsQuery({
    employee_id: employeeId,
  });
  return (
    <Box data-testid="ExpenseDetails-wrapper">
      <Box direction="column" background="module" pad="spacing24" round="moduleRound">
        <Box pad={{ vertical: 'spacing8' }} margin={{ bottom: 'spacing16' }} height={{ max: '40px' }}>
          <Text weight="bold" size="16px">
            Expense Breakdown
          </Text>
        </Box>
        {isLoading ? (
          <Preloader testId="loading-spinner" />
        ) : (
          <Box>
            <ExpensesBreakdown
              options={formattedData?.expenses || []}
              totalExpense={formattedData?.totalExpenses}
              inlineMode
            />
          </Box>
        )}
      </Box>
      <Box>
        <ExpensesList />
      </Box>
    </Box>
  );
};
